const songManagementTeamEmails = []

export function isEmailInSongManagementTeam(email) {
  if (email === null || email === undefined) {
    return false
  }
  return songManagementTeamEmails.includes(email)
}
